const {
  GET_LIST_TRANSPORT_GROUP,
  GET_LIST_TRANSPORT_GROUP_SUCCESS,
  GET_LIST_TRANSPORT_GROUP_ERROR,
} = require("./actions");

const initialState = {
  list: {
    isLoading: false,
    error: undefined,
    items: undefined,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_TRANSPORT_GROUP:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case GET_LIST_TRANSPORT_GROUP_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          items: action.payload.items,
        },
      };
    case GET_LIST_TRANSPORT_GROUP_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.error,
        },
      };

    default:
      return state;
  }
};

export default reducer;
